/**
 * @file Submission read-only / review UI components — types.ts.
 */

import type { ReactNode } from "react";
import type { AnyObj } from "../readonlyFormDisplay";

/** Exported const — DATASET OVERVIEW SECTION KEYS. */
export const DATASET_OVERVIEW_SECTION_KEYS = [
  "contributor-details",
  "publication-details",
  "background-data",
  "a1",
  "a2",
  "a3",
  "a1a3",
] as const;

/** Type definition — Dataset Overview Section Key. */
export type DatasetOverviewSectionKey =
  (typeof DATASET_OVERVIEW_SECTION_KEYS)[number];

/** Type definition — Dataset Overview Form Variant. */
export type DatasetOverviewFormVariant =
  | "contributor"
  | "publication"
  | "background"
  | "lifecycle-a1"
  | "lifecycle-a2"
  | "lifecycle-a3"
  | "a1a3";

/** Type definition — Dataset Overview Section Context. */
export type DatasetOverviewSectionContext = {
  submission: AnyObj;
  showA1: boolean;
  showA2: boolean;
  showA3: boolean;
  showA1A3: boolean;
};

/** Type definition — Dataset Overview Section Definition. */
export type DatasetOverviewSectionDefinition = {
  key: DatasetOverviewSectionKey;
  title: string;
  description?: string;
  renderBody: (ctx: DatasetOverviewSectionContext) => ReactNode;
};
